module.exports = __webpack_public_path__ + "static/media/QuickMenuIcon01_1.e4a608cf.svg";